var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSdkDevelopmentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11 3a1 1 0 1 1 2 .025 1 1 0 0 0-.015.152A1 1 0 0 1 11 3m3.654 1.4a3 3 0 1 1 .286-2 11 11 0 0 1 8.024 9.67 1 1 0 1 1-1.993.169A9 9 0 0 0 14.654 4.4M3.023 17.053a1 1 0 1 1-.175.078q.093-.03.175-.079m.206-2.05a8.965 8.965 0 0 1 3.62-9.375 1 1 0 0 0-1.14-1.643 10.965 10.965 0 0 0-4.355 11.77 3 3 0 1 0 1.874-.752M20.664 17a1 1 0 0 0-.662 1.75 1 1 0 0 1 .149.108l.002.002a1 1 0 1 0 .511-1.86m-3 1c0 .584.167 1.129.455 1.59a8.955 8.955 0 0 1-9.948 1.546 1 1 0 0 0-.857 1.807 10.95 10.95 0 0 0 12.388-2.1A3 3 0 1 0 17.664 18",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sync_svg__a)",
    fillRule: "evenodd",
    d: "M11 3a1 1 0 1 1 2 .025 1 1 0 0 0-.015.152A1 1 0 0 1 11 3m3.654 1.4a3 3 0 1 1 .286-2 11 11 0 0 1 8.024 9.67 1 1 0 1 1-1.993.169A9 9 0 0 0 14.654 4.4M3.023 17.053a1 1 0 1 1-.175.078q.093-.03.175-.079m.206-2.05a8.965 8.965 0 0 1 3.62-9.375 1 1 0 0 0-1.14-1.643 10.965 10.965 0 0 0-4.355 11.77 3 3 0 1 0 1.874-.752M20.664 17a1 1 0 0 0-.662 1.75 1 1 0 0 1 .149.108l.002.002a1 1 0 1 0 .511-1.86m-3 1c0 .584.167 1.129.455 1.59a8.955 8.955 0 0 1-9.948 1.546 1 1 0 0 0-.857 1.807 10.95 10.95 0 0 0 12.388-2.1A3 3 0 1 0 17.664 18",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sync_svg__a",
    x1: 12.004,
    x2: 12.004,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70DCD3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdkDevelopmentIcon);
export default __webpack_public_path__ + "static/media/sdk-development-icon.77b474d4f9b18b8171d53369da44028a.svg";
export { ForwardRef as ReactComponent };